<template>
  <div style="background:#fff">
    <van-nav-bar
      :title="$t('m.jy_span0')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div style="padding:0px;">
      <div
        class="top"
        style="position: relative; padding:15px 14px 4px 14px;height: 175px;"
      >
      <div style="position: absolute;right:14px;top:80px;background:#FF3738;border-radius:20px 0 0 20px;color:#fff;font-size:13px;display:flex;align-items:center;height:30px;width: 106px;padding:0 10px;">
        <img src="../../assets/images/new/baozhang.png" style="width: 16px;height: 16px;margin-right:4px;" alt="">
        {{$t('m.jy_span01')}}
      </div>
        <div style="background-color:#fff;color:#000;border-radius:10px;padding:30px 15px 10px 15px;box-shadow: 0px 0px 16px #eaeaea;margin-top:40px;">
             <div class="content">
          <div class="title" style="font-size:14px;color:#777">{{$t('m.jy_span02')}}</div>
          <div class="price" style="display:flex;align-items:center;font-size:24px;font-weight:bold;">
            <span style="flex:1;">{{ zongqian }}</span>
          </div>
        </div>
        <div class="zhr" style="margin-top:20px;">
          <div style="flex:1;">
            <p style="font-size:12px;margin-top:4px;color:#777;">{{$t('m.jy_span2')}}</p>
            <p style="font-size:18px;">{{ daishou }}</p>
            
          </div>
          <div style="flex:1;">
            <p style="font-size:12px;margin-top:4px;color:#777;">{{$t('m.jy_span3')}}</p>
            <p style="font-size:18px;">{{ yishou }}</p>
            
          </div>
          <!-- <div>
            <p style="font-size:18px;">{{ userInfo.integral }}</p>
            <p style="font-size:13px;margin-top:4px;">积分</p>
          </div> -->
          <!-- <div>
          <p>{{ userInfo.integral }}</p>
        </div> -->
        </div>
        </div>
       
      </div>
    </div>
    <div style="display:flex;align-items:center;justify-content:center;margin-top:100px;">
      <div @click="chongzhi" style="margin-right:20px; display:flex;align-items:center;justify-content:center;background:#FFDDB7;height: 35px;line-height:35px;width: 130px;border-radius:20px;color:#D50000;font-weight:bold;font-size:14px;">
        <img src="../../assets/images/new/chong.png" style="width: 15px;height: 15px;margin-right:5px;" alt="">
        {{$t('m.jy_span4')}}
      </div>
       <div @click="tixian" style="display:flex;align-items:center;justify-content:center;background:#FF3738;height: 35px;line-height:35px; width: 130px;border-radius:20px;color:#fff;font-weight:bold;font-size:14px;">
        <img src="../../assets/images/new/ti.png" style="width: 15px;height: 15px;margin-right:5px;" alt="">
        {{$t('m.jy_span5')}}
      </div>
    </div>
    <div style="height: 10px;width: 100%;background:#F5F5F8;margin-top:20px;"></div>
    <div class="wdcy" style="border-bottom:8px solid #fff;color:#999;padding-right:15px;padding-top:5px;"> 
      <span style="font-size:15px;margin-right:15px;">{{$t('m.jy_span03')}} </span>
      <div style="flex:1;display:flex;align-items:center;font-size:13px;">
        <img src="../../assets/images/new/yuanxin.png" style="width: 14px;height: 14px;margin-right:3px;" alt="">{{$t('m.jy_span04')}}
      </div>
      <span  style="font-size:13px;">{{$t('m.jy_span9')}}</span>
    </div>
    <div class="detail_card" style="background:#fff;padding-left:15px;">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="onLoad"
      >
        <div class="item" v-for="(item, index) in list" :key="index" style="padding:0; margin-bottom:12px;box-shadow: 0px 0px 16px #eaeaea;padding-right:0px;">
          <div style="display:flex;align-items:center;">
            <div style="width: 30px;height: 30px;background-color:#fff;position: relative;left:-15px;box-shadow: 0px 0px 16px #eaeaea;border-radius:50%;text-align:center;">
              <img :src="imgs1[index%6]" style="width: 20px;height: 20px;margin-top:5px;" alt="">
            </div>
            <div style="flex:1;position: relative;left:-10px;">
               <div class="title-item">
            <span class="line-clamp1">{{ item.title }}</span>
            <p style="font-size:17px;color:red;font-size:17px;">+{{ item.receive_profit }}</p>
          </div>
          <div class="title-item" style="color:#999;font-size:12px;border-bottom:0 solid;">
            <span style="color:#999;font-size:12px;">{{$t('m.tz_span4')}}{{ item.money }}</span>
            <p style="font-size:12px;">{{$t('m.jy_span8')}}{{ item.rate }}</p>
          </div>
            </div>
          </div>
          <!-- <div class="top-item">
            <div>
              <i style="font-size:12px;">持仓金额</i>
              <p style="margin-top:8px;color: red;font-size:20px;">{{ item.money }}</p>
            </div>
            <div>
              <i style="font-size:12px;">日利率</i>
              <p style="margin-top:8px;color: red;font-size:20px;">{{ item.rate }}</p>
            </div>
            <div>
              
              
            </div> 
          </div>-->
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";
export default {
  data() {
    return {
      imgs1: [
        require("../../assets/images/new/bb1.png"),
        require("../../assets/images/new/bb2.png"),
        require("../../assets/images/new/bb3.png"),
        require("../../assets/images/new/bb4.png"),
        require("../../assets/images/new/bb5.png"),
        require("../../assets/images/new/xiaoli.png"),
        
      ],
      data: {},
      userInfo: {},
      list: [],
      page: 0,
      daishou: 0,
      yishou: 0,
      zongqian:0,
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  created() {
    let that = this;
    setTimeout(() => {
       request
      .post("/user/user/index", {}, { login: true })
      .then(res => {
        console.log("积分");
        console.log(res);
        that.userInfo = res.data.data;
      })
      .catch(err => {
        that.$dialog.error(err.response.data.msg);
      });
    }, 1000);
    setTimeout(() => {
      that.requ()
    }, 1500);
   
  },
  methods: {
    requ() {
      getMyUserInfo().then(res => {
        
        this.zongqian = res.data.data.tmoney;
      });
    },
    chongzhi(){
  this.$router.push({
        path: "/CzContent"
      });
    },
    tixian(){
  this.$router.push({
        path: "/txCash"
      });
    },
    jiaoyi() {
      this.$router.push({
        path: "/moneyDetail"
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    fanhui() {
      window.history.go(-1);
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;

      request
        .get("/fund/log/list", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          this.yishou = res.data.data.tongji.yishou;
          this.daishou = res.data.data.tongji.daishou;
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            console.log(res.data.data.list[i]["end_time"]);
            console.log(new Date().getTime() / 1000);
            this.list.push({
              id: res.data.data.list[i]["id"],
              title: res.data.data.list[i]["title"],
              code: res.data.data.list[i]["cday"],
              income: res.data.data.list[i]["income"],
              money: res.data.data.list[i]["money"],
              rate: res.data.data.list[i]["rate"],
              clock: res.data.data.list[i]["clock"],
              end_time:
                (res.data.data.list[i]["end_time"] -
                  new Date().getTime() / 1000) *
                1000,
              receive_profit: res.data.data.list[i]["profit"]
            });
          }
          this.loading = false;

          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);

          this.finished = true;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped lang="less">
.top{
   margin-top: -46px;
    // padding: 15px 0;
    background-image: url(../../assets/images/new/jiaoyiback.jpg);
    background-repeat: no-repeat;
    background-size: 100% 175px;
}
/deep/ .van-hairline--bottom::after{
  border-bottom-width: 0px;
}
.van-nav-bar {
	box-shadow: none;
}
.colon {
  display: inline-block;
  margin: 0 4px;
}
.block {
  display: inline-block;
  width: 22px;
  color: #ee0a24;
  font-size: 12px;
  text-align: center;
}
.myInvest /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.myInvest /deep/ .van-nav-bar__title {
  color: #fff;
}
.myInvest /deep/ .van-icon {
  color: #fff;
}
.myInvest {
  height: 100vh;
  background-color: #f6f6f6;
  .content {
    margin-top: -46px;
    padding: 15px 0;
    background-image: url(../../assets/images/bg.png);
    background-repeat: no-repeat;
    background-size: 100% 175px;
    .interest_card {
      padding: 15px 0;
      display: flex;
      border-radius: 5px;
      margin: 100px 15px 0;
      background-color: #fff;
      box-shadow: 0px 0px 6px #eaeaea;
      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
        }
      }
    }
    .detail_card {
      // background: #dfdfdf;
      margin-top: 10px;
      font-size: 14px;
      .card_item {
        padding: 15px 20px 10px;
        margin-bottom: 10px;
        border-radius: 5px;
        background-color: #fff;
        .item_title {
          padding-bottom: 15px;
          border-bottom: 1px solid #f2f2f2;
        }
        .purchase_code,
        .order_num,
        .get_money {
          line-height: 30px;
          color: #333;
        }
        .get_money_detail {
          display: flex;
          justify-content: space-between;
          color: #333;
          div {
            display: flex;
            flex-direction: column;
            span:nth-child(1) {
              padding: 10px 0;
              font-size: 12px;
              color: #666;
            }
          }
        }
      }
    }
    .loading_finish {
      text-align: center;
      margin-top: 10px;
      font-size: 12px;
      color: #666;
    }
  }
}
.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.jiangli_top {
  background: #fff !important;
  position: relative;
}
.title-item {
  display: flex;
  justify-content: space-between;
  height: 50px;

  line-height: 50px;
  border-bottom: 1px solid #eee;
}

.title-item span {
  font-size: 15px;
  font-weight: 700;
  color: #444;
}

.title-item i {
  color: #c1c1c1;
}

.item {
  margin: 0 20px;
  margin: 0 10px;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
}

.jl {
  position: absolute;
  right: 10px;
  top: 0;
  color: #dee1e6;
}

.top {
  padding-top: 20px;

  font-weight: bold;
  color: #fff;
}

.content {
  margin-bottom: 15px;
}

.price {
  font-size: 28px;
  margin-top: 6px;
}
.title {
  font-size: 14px;
  color: #c1c1c1;
}

.zhr {
  display: flex;
  
  padding: 0 0px 20px 0px;
}
.zhr p {
  margin-top: 3px;
}

.top-item {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.top-item > div {
  text-align: center;
}
.top-item > div > i {
  color: #c1c1c1;
  margin-bottom: 5px;
}
.top-item > div > p {
  font-weight: bold;
  font-size: 25px;
}

.zhr > div > i {
  color: #dee1e6;
  margin-bottom: 5px;
}
.wdcy {
  display: flex;
  align-items: center;;
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: bold;
}
/deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-nav-bar .van-icon {
  color: #fff;
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
</style>
